/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_PasswordInputs */

const en_new_password = /** @type {(inputs: New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Password`)
};

const es_new_password = /** @type {(inputs: New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva contraseña`)
};

const fr_new_password = /** @type {(inputs: New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau mot de passe`)
};

const de_new_password = /** @type {(inputs: New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Passwort`)
};

const ja_new_password = /** @type {(inputs: New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいパスワード`)
};

const zh_new_password = /** @type {(inputs: New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新密码`)
};

const ar_new_password = /** @type {(inputs: New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كلمة المرور الجديدة`)
};

const id_new_password = /** @type {(inputs: New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kata Sandi Baru`)
};

const it_new_password = /** @type {(inputs: New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuova Password`)
};

const ru_new_password = /** @type {(inputs: New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новый пароль`)
};

const pt_new_password = /** @type {(inputs: New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova Senha`)
};

const ko_new_password = /** @type {(inputs: New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 비밀번호`)
};

/**
* | output |
* | --- |
* | "New Password" |
*
* @param {New_PasswordInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const new_password = /** @type {((inputs?: New_PasswordInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_PasswordInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_new_password(inputs)
	if (locale === "es") return es_new_password(inputs)
	if (locale === "fr") return fr_new_password(inputs)
	if (locale === "de") return de_new_password(inputs)
	if (locale === "ja") return ja_new_password(inputs)
	if (locale === "zh") return zh_new_password(inputs)
	if (locale === "ar") return ar_new_password(inputs)
	if (locale === "id") return id_new_password(inputs)
	if (locale === "it") return it_new_password(inputs)
	if (locale === "ru") return ru_new_password(inputs)
	if (locale === "pt") return pt_new_password(inputs)
	return ko_new_password(inputs)
});